import {Attribute, Directive, ElementRef, inject, Injector, Optional} from '@angular/core';

import {
  DISPLAY_TYPE,
  IWidgetConfig,
  StylableComponent,
  provideAsWidgetRef,
  Parent,
  register,
  styler,
  APPLY_STYLES_TYPE
} from "@wm/components-base";
import {isMobileApp, switchClass, Viewport} from "@wm/core";
import {setCSS} from "@wm/core";

const DEFAULT_CLS = 'app-grid-column';
const WIDGET_CONFIG: IWidgetConfig = {
  widgetType: 'wm-gridcolumn',
  hostClass: DEFAULT_CLS
};

@Directive({
  selector: '[wmLayoutGridColumn]',
  providers: [
  provideAsWidgetRef(LayoutGridColumnDirective)
  ],
  standalone: true,
  exportAs: 'wmLayoutGridColumn'
})
export class LayoutGridColumnDirective extends StylableComponent {
  static initializeProps = register('wm-gridcolumn');
 private eleRef:ElementRef
  deviceType:any

  constructor(inj: Injector,
              @Attribute('height')height:any,private viewport :Viewport,
              @Optional() viewParent: Parent) {
    super(inj, WIDGET_CONFIG, viewParent);
    this.eleRef= inject(ElementRef);
    this.deviceType = "web";
    if (height) {
      setCSS(this.nativeElement, 'overflow', 'auto');
    }
    styler(this.nativeElement, this,APPLY_STYLES_TYPE.CONTAINER);
  }

  protected override onPropertyChange(this:any,key: string, nv: any, ov?: any,) {
    const prefix = isMobileApp() ? 'xs' : 'sm';
    if (key === 'xscolumnwidth' && this.viewport.isMobileType && isMobileApp()) {
      switchClass(this.nativeElement, `col-${prefix}-${nv}`, ov ? `col-${prefix}-${ov}` : '');
    } else if (key === 'columnwidth') {
      if (!isMobileApp() || (this.viewport.isMobileType &&!this.$attrs.get('xscolumnwidth') ) || !this.viewport.isMobileType) {
        switchClass(this.nativeElement, `col-${prefix}-${nv}`, ov ? `col-${prefix}-${ov}` : '');
      }
    } else {
      super.onPropertyChange(key, nv, ov);
    }
  }



}

